import {combineReducers} from 'redux';
import {
  registerStatusListener as registerOnlineStatusListener
} from '../module/Offline';
import {
  registerStatusListener as registerAPIStatusListener
} from '../module/API';
const ADMIN_COUNT = 10;

// *** REDUCERS

const adminVisibleReducer = (state = {
    count: 0,
    adminVisible: false,
  }, action) => {

  let newCount;

  switch(action.type) {

    case 'SPECIAL_COUNT':
      newCount = state.count + 1 % ADMIN_COUNT;
      return {
        ...state,
        count: newCount,
        adminVisible: newCount >= ADMIN_COUNT,
      };

    case 'CLEAR_SPECIAL_COUNT':
      return {
        ...state,
        count: 0,
      };

    case 'HIDE_ADMIN_VISIBILITY':
      return {
        ...state,
        adminVisible: false,
        count: 0,
      };

    default:
      return state;

  }

};

export const networkStatusReducer = (state = {}, action) => {

  switch(action.type) {

    case 'API_ONLINE':
      return {
        ...state,
        apiOnline: true,
      };

    case 'API_OFFLINE':
      return {
        ...state,
        apiOnline: false,
      };

    case 'NETWORK_ONLINE':
      return {
        ...state,
        networkOnline: true,
      };

    case 'NETWORK_OFFLINE':
      return {
        ...state,
        networkOnline: false,
      };

    default:
      return state;

  }

};

export const checkingNetworkStatusReducer = (state = {}, action) => {

  switch(action.type) {

    case 'CHECKING_ONLINE_STATUS':
      return {
        ...state,
        apiChecked: false,
        networkChecked: false,
      };

    case 'NETWORK_ONLINE':
    case 'NETWORK_OFFLINE':
      return {
        ...state,
        networkChecked: true,
      };

    case 'API_ONLINE':
    case 'API_OFFLINE':
      return {
        ...state,
        apiChecked: true,
      };

    default:
      return state;

  }

}

export const offlineContentReducer = (state = {}, action) => {

  switch(action.type) {

    case 'NEW_CONTENT_AVAILABLE':
      return {
        ...state,
        newContent: true,
        contentCached: false,
      };

    case 'CONTENT_CACHED_FOR_OFFLINE':
      return {
        ...state,
        contentCached: true,
      };

    default:
      return state;

  }

};

// *** MAIN REDUCER

export default combineReducers({
  adminVisible: adminVisibleReducer,
  networkStatus: networkStatusReducer,
  checkingNetworkStatus: checkingNetworkStatusReducer,
  offlineContent: offlineContentReducer,
});

// *** SELECTORS

export const adminVisibleSelector = (state) => state.adminVisible.adminVisible;
export const networkStatusSelector = (state) => (state.networkStatus.apiOnline && state.networkStatus.networkOnline) ? true : false;
export const checkingNetworkStatusSelector = (state) => (state.checkingNetworkStatus.apiChecked && state.checkingNetworkStatus.networkChecked) ? false : true;
export const newContentAvailableSelector = (state) => state.offlineContent.newContent ? true : false;
export const contentCachedSelector = (state) => state.offlineContent.contentCached ? true : false;

// *** ACTIONS

export const addSpecialCount = () => {
  return {
    type: 'SPECIAL_COUNT',
  };
};

export const clearSpecialCount = () => {
  return {
    type: 'CLEAR_SPECIAL_COUNT',
  };
};

export const hideAdminVisibility = () => {
  return {
    type: 'HIDE_ADMIN_VISIBILITY',
  };
};

export const registerOnlineListener = () => {
  return (dispatch) => {
    dispatch({
      type: 'CHECKING_ONLINE_STATUS',
    });

    registerOnlineStatusListener(status => {
      if ( status ) {
        dispatch({
          type: 'NETWORK_ONLINE',
          ts: Date.now(),
        });
      } else {
        dispatch({
          type: 'NETWORK_OFFLINE',
          ts: Date.now(),
        });
      }
    });

    registerAPIStatusListener(status => {
      if ( status ) {
        dispatch({
          type: 'API_ONLINE',
          ts: Date.now(),
        });
      } else {
        dispatch({
          type: 'API_OFFLINE',
          ts: Date.now(),
        });
      }
    });
  };
};



// WEBPACK FOOTER //
// ./src/reducers/applicationReducer.js